import {
  handleSelectAllBySwitch,
  handleLocationSelectBySwitch,
  handleSpecificLocationSelectBySwitch,
  handleMachineSelectBySwitch,
  handleAddLocationsBySwitch,
  handleAddSpecificLocationsBySwitch,
  handleAddMachinesBySwitch,
  handleMachineSelectAltBySwitch,
  handleMachineSelectWithSpecLocationAltBySwitch,
} from 'shared/slice/masterControlBySwitchSelectSlice';
import {
  handleSelectAllByLocation,
  handleLocationSelectByLocation,
  handleSpecificLocationSelectByLocation,
  handleMachineSelectByLocation,
  handleAddLocationsByLocation,
  handleAddSpecificLocationsByLocation,
  handleAddMachinesByLocation,
  handleMachineSelectAltByLocation,
  handleMachineSelectWithSpecLocationAltByLocation,
} from 'shared/slice/masterControlSelectByLocationSlice';

const SCOPE_ACTIONS = {
  switch: {
    selectAll: handleSelectAllBySwitch,
    locationSelect: handleLocationSelectBySwitch,
    specificLocationSelect: handleSpecificLocationSelectBySwitch,
    machineSelect: handleMachineSelectBySwitch,
    addLocations: handleAddLocationsBySwitch,
    addSpecificLocations: handleAddSpecificLocationsBySwitch,
    addMachines: handleAddMachinesBySwitch,
    machineSelectAlt: handleMachineSelectAltBySwitch,
    machineSelectWithSpecLocationAlt: handleMachineSelectWithSpecLocationAltBySwitch,
  },
  location: {
    selectAll: handleSelectAllByLocation,
    locationSelect: handleLocationSelectByLocation,
    specificLocationSelect: handleSpecificLocationSelectByLocation,
    machineSelect: handleMachineSelectByLocation,
    addLocations: handleAddLocationsByLocation,
    addSpecificLocations: handleAddSpecificLocationsByLocation,
    addMachines: handleAddMachinesByLocation,
    machineSelectAlt: handleMachineSelectAltByLocation,
    machineSelectWithSpecLocationAlt: handleMachineSelectWithSpecLocationAltByLocation,
  },
};

export const getScopeActions = (scope) =>
  SCOPE_ACTIONS[scope] || SCOPE_ACTIONS.location;
